import { OMS_RECYCLE_ORDER_TYPE_MAP } from 'commons/options';
import { SHOP_MAP } from 'constant/shop';
import type { ContractPrintProduct, ContractType } from './utils';

const getContractPrintList = ({
  storeId,
  type,
  productList,
  customerOnly = false,
  storeOnly = false,
}: {
  storeId: number;
  type: number;
  productList: ContractPrintProduct[];
  customerOnly?: boolean;
  storeOnly?: boolean;
}): { type: ContractType; productList: ContractPrintProduct[] }[] => {
  const isConsignmentOrder = type === OMS_RECYCLE_ORDER_TYPE_MAP.CONSIGNMENT;
  const customerType: ContractType = isConsignmentOrder
    ? 'SELL_CUSTOMER'
    : 'RECYCLE_CUSTOMER';
  const storeType: ContractType = isConsignmentOrder
    ? 'SELL_STORE'
    : 'RECYCLE_STORE';
  const contractTypes = (() => {
    if (storeOnly) return [storeType];
    if (customerOnly) return [customerType];

    return [customerType, storeType];
  })();

  const isJpOrder = storeId === SHOP_MAP.GINZA || storeId === SHOP_MAP.UMEDA;

  // 日本的寄卖订单，每个商品需要拆分打印
  if (isJpOrder && isConsignmentOrder) {
    return productList.flatMap((product) =>
      contractTypes.map((contractType) => ({
        type: contractType,
        productList: [product],
      })),
    );
  }

  return contractTypes.map((contractType) => ({
    type: contractType,
    productList,
  }));
};

export default getContractPrintList;
